import { render, staticRenderFns } from "./StaticFolderList.vue?vue&type=template&id=40f740ad"
import script from "./StaticFolderList.vue?vue&type=script&lang=js"
export * from "./StaticFolderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports